import { createLucideIcon } from "lucide-react";

export const ChevronUpCircle = createLucideIcon(
    "ChevronUpCircle",
    [
        [
            "path",
            {
                d: "M8 13.5L11.7 10.725C11.8778 10.5917 12.1222 10.5917 12.3 10.725L16 13.5",
                key: "2mau24",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
